import { render, staticRenderFns } from "./notifications-view-widget.vue?vue&type=template&id=a86db0d0&"
import script from "./notifications-view-widget.vue?vue&type=script&lang=js&"
export * from "./notifications-view-widget.vue?vue&type=script&lang=js&"
import style0 from "./notifications-view-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports